'use strict';

function isInteger(n) {
  return n % 1 === 0;
}

module.exports = isInteger;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/internal/isInteger.js
// module id = 302
// module chunks = 0